import { useEffect } from 'react';
import { useLocation } from 'react-router';

const ADMIN_ROUTES = {
  'admin/offer-manager': 'Offer Manager',
  'admin/tradebooks': 'Tradebook Settings',
  'admin/pre-ownedaprrates': 'Pre-owned Rates',
  'admin/dms': 'DMS Mapper',
  'admin/crm': 'CRM Mapper',
  'admin/users': 'User Management',
  'admin/hours': 'Hours of Operation',
  'admin/dataexport': 'Data Export',
  admin: 'Store Settings',
};

const REPORTING_ROUTES = {
  'reporting/private-incentive/privateIncentiveInsights': 'Private Incentive Insights',
  'reporting/service-portfolio/service-portfolio': 'Service Portfolio Insights',
  'reporting/performance/performanceInsights': 'Performance Insights',
};

export const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let title = 'Mastermind';
    if (path.includes('dealsheet')) {
      return;
    }
    // Loyalty Portfolio
    if (path.includes('portfolio')) title = 'Portfolio - ' + title;

    // Service Portfolio
    if (path.includes('service')) title = 'Service - ' + title;

    // Acquire
    if (path.includes('acquire')) title = 'Acquire - ' + title;

    // Turn
    if (path.includes('turn/details')) {
      title = 'Turn Details - ' + title;
    } else if (path.includes('turn')) {
      title = 'Turn - ' + title;
    }

    // Digital Audience
    if (path.includes('digital-audience')) title = 'Digital Audience - ' + title;

    // Insights
    const reportingRoute = Object.keys(REPORTING_ROUTES).find((route) => path.includes(route));
    if (reportingRoute) {
      title = `${REPORTING_ROUTES[reportingRoute]} - ${title}`;
    }

    //  PIL
    if (path.includes('privateincentivelookup')) title = 'Private Incentive Lookup - ' + title;

    // Market Impact
    if (path.includes('market-impact')) title = 'Market Impact - ' + title;

    // Market Impact Summary
    if (path.includes('market-impact-summary')) title = 'Market Impact Summary - ' + title;

    // Store Settings
    const adminRoute = Object.keys(ADMIN_ROUTES).find((route) => path.includes(route));
    if (adminRoute) {
      title = `${ADMIN_ROUTES[adminRoute]} - ${title}`;
    }

    document.title = title;

    return () => {
      document.title = 'Mastermind';
    };
  }, [location.pathname]);
};
